import goldenowlLogo from '@/assets/goldenowl-logo.svg';
import godiLogo from '@/assets/godi-logo.svg';

export default function Partners({ t }) {
  return (
    <section className="partners">
      <div className="container">
        <div className="reveal partners-card">
          <div className="partners-label">{t.label}</div>
          <div className="partners-logos">
            <img className="golden" src={goldenowlLogo} alt="Golden Owl Solutions" />
            <img className="godi" src={godiLogo} alt="Godi" />
          </div>
        </div>
      </div>
    </section>
  );
}
